import { render } from "./alertDialogBottom.vue?vue&type=template&id=3768e8ba&scoped=true"
import script from "./alertDialogBottom.vue?vue&type=script&lang=js"
export * from "./alertDialogBottom.vue?vue&type=script&lang=js"

import "./alertDialogBottom.vue?vue&type=style&index=0&id=3768e8ba&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3768e8ba"]])

export default __exports__